import { Calendar } from "primereact/calendar"
import { useField } from "formik"

import { Skeleton } from "primereact/skeleton"

//Style
import styles from "../../styles/Form-Inputs.module.css"

export default function FormikCalendar({
  name,
  label,
  placeholderText,
  helpText,
  disabled,
  required,
  isInitialLoad,
  minDate,
  maxDate,
  disableFormikSubmit, //Does not submit changes to formik. Can be used in conjunction with onChangeCallBack for manual processing
  onChangeCallBack,
  showTime,
  showIcon,
  icon,
  timeOnly,
  hourFormat,
  selectionMode, //single (default), multiple, range
}) {
  const [field, meta, helpers] = useField(name)

  let value = undefined

  if (!selectionMode || selectionMode !== "multiple") {
    value = !!field.value ? new Date(field.value) : undefined
  } else {
    value = !!field.value
      ? field.value?.map((value) => new Date(value))
      : undefined
  }

  const getCalendar = () => {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      return (
        <>
          <Calendar
            value={value}
            name={name}
            disabled={disabled}
            onChange={(e) => {
              if (!disableFormikSubmit) {
                helpers.setValue(e.value)
              }

              if (!!onChangeCallBack) {
                onChangeCallBack(e.value)
              }
            }}
            className={meta.touched && meta.error ? "p-invalid" : undefined}
            style={{ width: "100%" }}
            minDate={minDate}
            maxDate={maxDate}
            showTime={showTime}
            hourFormat={hourFormat || "12"}
            placeholder={placeholderText}
            timeOnly={timeOnly}
            showIcon={showIcon}
            iconPos="left"
            icon={icon}
            selectionMode={selectionMode}
          />
          {meta.touched && meta.error ? (
            <label id={`${name}-error`} className={styles.errFieldMsg}>
              {meta.error}
            </label>
          ) : null}
        </>
      )
    }
  }

  const labelField = () => {
    if (isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return (
        <label>
          {label} {required ? <span style={{ color: "red" }}> * </span> : null}
        </label>
      )
    }
  }

  return (
    <div className={styles.field}>
      <label>{labelField()}</label>
      <div>
        {helpText ? (
          <div style={{ marginBottom: "10px" }}>
            <small style={{ color: "gray" }}>{helpText}</small>
          </div>
        ) : null}
        {getCalendar()}
      </div>
    </div>
  )
}
